module.exports = __webpack_public_path__ + "static/media/part-13.c34327c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/part-13.jpg
// module id = 946
// module chunks = 0